<template>
	<div class="group-doc hoverable-background" @click="$emit('activate',doc)">
		<div>
			<p>
				{{doc.name}}
			</p>
		</div>
		<div class="level is-mobile">
			<div class="level-left">
				<div class="level-item">
					<a class="button is-text has-text-grey">
						<img class="icon image is-16x16" src="../../../assets/svg/about_obj.svg" />
						<span class="hoverable-underline">о документе</span>
					</a>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	export default {
		props: {
			doc: {
				type: Object,
				required: true
			}
		}
	}
</script>
<style>
	.group-doc {
		cursor: pointer;
		border-bottom: 1px solid #EFEFEF;
		margin: 0 -2rem 0rem -2rem;
		padding: 1rem 2rem 0.5rem 2rem;
	}
</style>